import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs';

import { UserService } from './user.service';
import { map, take, tap } from 'rxjs/operators';
import 'rxjs/add/observable/of';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  canLoad(route: ActivatedRouteSnapshot): Observable<boolean> {

    return this.isLoggedIn();

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    return this.isLoggedIn().pipe(map(loggedIn => {
      if (
        !loggedIn ||
        this.userService.getCurrentUser().role === 'ROLE_API_OBSERVER' ||
        (route.data.notForObserver && this.userService.getTypeOfUser() === 'Observer') ||
        (this.userService.getCurrentUser().role === 'ROLE_API_CARETAKER' && route.data.expectedRole === 'ROLE_API_MANAGER') ||
        this.userService.getRole() < this.userService.getIntRole(route.data.expectedRole)
      ) {
        return false;
      }
      return !route.data.privilege || !!this.userService.getPrivilegeEko();
    }));

  }

  private isLoggedIn(): Observable<boolean> {
    return this.userService.isAuthenticated
      .pipe(
      take(1),
      tap(loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['/auth/login']);
        }
      })
      );
  }

}
